import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryInstructionStatus extends BaseModelAPI {
	static entity = 'deliveryinstructionstatus';
	static entityName = 'deliveryinstructionstatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.sequence = 0;
			this.remarks = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}